import {getService} from "~/lib/services/services-manager";
import {generateQueryString} from "~/lib/querystring";

export const fetchTilesetResult = async opts => {

  const service = getService("server-app");

  let params;

  if( opts.ids ){
    params = { ids: opts.ids };
  } else if( opts.geoCodes){
    params = { geoCodes: opts.geoCodes };
  } else {
    params = {
      query: opts.query || "",
      offset : opts.offset || 0
    };
  }

  if (opts.bypassTerritory) {
    params.bpterr = 1;
  }

  const result = await service.get(`/geometries/tile-set/${opts.tsId}/entities${generateQueryString(params)}`);
  return result.data.entities;
};

export const getTileSet = async tsID => {
  const service = getService("server-app");
  const result = await service.get(`/geometries/tile-set/one${generateQueryString({id: tsID})}`);
  return result.data.tileSet;
}
